// IndicatorScorecard — the reusable indicator card of the Analysis view
// (US-879 · R-2). Renders one already-formatted value from analysisConfig;
// a null/undefined value shows an em dash — the panel never invents data
// (R-7). US-880/881 reuse this card for the Digitalization Index and the
// extended scorecard instead of introducing new card shapes.
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const IndicatorScorecard = ({ label, value, caption }) => (
  <Box
    sx={{
      border: 1,
      borderColor: "divider",
      borderRadius: 1.5,
      px: 1.5,
      py: 1.25,
      bgcolor: "background.paper",
      minWidth: 0,
    }}
  >
    <Typography
      component="p"
      sx={{
        fontSize: 11,
        fontWeight: 700,
        letterSpacing: "0.06em",
        textTransform: "uppercase",
        color: "text.secondary",
      }}
    >
      {label}
    </Typography>
    <Typography
      component="p"
      sx={{ fontSize: "1.25rem", fontWeight: 700, lineHeight: 1.3, mt: 0.25 }}
    >
      {value ?? "—"}
    </Typography>
    {caption && (
      <Typography variant="caption" sx={{ color: "text.secondary", lineHeight: 1.35 }}>
        {caption}
      </Typography>
    )}
  </Box>
);

export default IndicatorScorecard;
